<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            range
            defaultStart="-3M"
            defaultEnd="0d"
            label="기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            stepperGrpCd="SOP_FIRE_FIGHTING_TRANING_EDU_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingTraningEduStepCd"
            label="진행단계"
            v-model="searchParam.sopFireFightingTraningEduStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="주관부서"
            name="deptCd"
            v-model="searchParam.deptCd"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방 훈련·교육 계획/결과 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="openPop" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingTraningEdu',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        sopFireFightingTraningEduStepCd: null,
        deptCd: '',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'traninigEduName',
            field: 'traninigEduName',
            label: '훈련·교육',
            align: 'left',
            sortable: true,
            style: 'width: 220px',
            type: 'link'
          },
          {
            name: 'sopFireFightingTraningEduStepName',
            field: 'sopFireFightingTraningEduStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 120px',
          },
          {
            name: 'traninigEduDt',
            field: 'traninigEduDt',
            label: '훈련·교육 일시',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'locationName',
            field: 'locationName',
            label: '장소',
            align: 'left',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '주관부서',
            align: 'center',
            sortable: true,
            style: 'width: 120px',
          },
          {
            name: 'sopFireFightingTraningEduTargetName',
            field: 'sopFireFightingTraningEduTargetName',
            label: '훈련·교육 대상',
            align: 'left',
            sortable: true,
            style: 'width: 180px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingTraningEdu.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    openPop() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = '소방 훈련·교육 상세';
      this.popupOptions.param = {
        sopFireFightingTraningEduId: row ? row.sopFireFightingTraningEduId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingTraningEduDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
